export const DisableObtKey = 'DisableObt';
export const DisableGdsKey = 'DisableGdsBooking';
